import React from 'react';
import {connect} from 'react-redux';
import {deepClone, sortBy, startCase, get, lowerCase} from 'lodash';
import {Link} from "react-router-dom";

// local imports
import api from '../../../store/api'
import {toggleGlobalLoader, addErrorAlert, addLoadingAlert, removeLoadingAlert} from "../../../store/calls/alertLoadingDispatch";
import AdminWrapper from "../../theme/wrappers/AdminWrapper";
import validators from "../../../utils/forms/validators";
import formatters from "../../../utils/forms/formatters";
import * as preconfiguredInputs from "../../../utils/forms/preconfiguredInputs";
import Input from "../../theme/forms/Input";
import BaseForm from "../../theme/forms/BaseForm";
import PaginatedTable from "../../theme/tables/PaginatedTable";
import ConfirmModal from "../../theme/modals/ConfirmModal";
import FormModal from "../../theme/modals/FormModal";
import SearchAndSelectModal from "../../theme/modals/SearchAndSelectModal";
import SelectByCategory from "../../theme/forms/SelectByCategory";
import * as actions from "../../../store/actions";
import {displaySummaryData} from "../../../utils/displayData";
import {flatFeeChargeTypeSelect} from "../../../utils/forms/preconfiguredInputs";
import {getUUID} from "../../../utils/hashFuncs";
import NoteBuilder from "../../subcomponents/admin/NotesSectionBuilder";


/*
NOTE TO SELF:

TOP IS A CARD, NAME OF PROGRAM AND SPECIFICATIONS, ALLOWS YOU TO EDIT.
BELOW IS A TABLE. SAME TABLE AS THE OTHER ONES, WHICH ALLOWS YOU TO EDIT.

I ALSO NEED TO BUILD A SEARCH FUNCTION THAT WILL ALLOW YOU TO ADD OR REMOVE DISTRICTS OR IMPROVEMENTS TO THIS.
*/
const SHOW_BUSINESS_ASSET_TABS = false;

class SPACommercialLoanProductSpecScreen extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            displayedData: [],
            displayedColumns: [],
            dataPullLimit: 25,
            dataPullOffset: 0,

            specInstance: {},// the actual pace program thing that is the focus of the spec page. Pulled by ID from URL.

            // edit and delete
            editModalOpen: false,
            deleteModalOpen: false,

            deletePaceProgramLoanProductModalOpen: false,
            addPaceProgramLoanProductModalOpen: false,
            paceProgramAdditionSearchResults: [],

            deleteAttributeModalOpen: false,
            addEditAttributeModalOpen: false,
            resetAttributeForm: 0,

            deleteFeeModalOpen: false,
            addEditFeeModalOpen: false,
            resetFeeForm: 0,

            deleteNoteModalOpen: false,
            addEditNoteModalOpen: false,
            resetNoteForm: 0,


            businessTypeList: [],
            changedBusinessTypes: false,
            assetTypeList: [],

            editingInstance: null,
            mode: 'term-sets', // can also be business-types or pace-programs
            categoryFilter: null,
            nameFilter: null,
        }

        this.specInstanceId = props.match.params.loanProductId;
        this.specFunderInstanceId = props.match.params.funderId;

        this.baseAPIPath = '/loan-products/' + this.specInstanceId + '/';

        this.editSpecInstanceInputs = [
            {
                label: 'Loan Product Type',
                dataKey: 'type',
                ...preconfiguredInputs.loanResidentialProductTypeSelect,
                ...validators.exists
            },
            {
                type: 'text',
                label: "Name",
                dataKey: "name",
                ...validators.isStringOfMinLength(2)
            },
            {
                type: 'textarea',
                label: "Description",
                dataKey: "description",
            },
            {
                type: 'text',
                label: "Minimum Deal Size",
                dataKey: "minimum_size",
                ...validators.isNumberWhenStripped,
                ...formatters.USDCurrency
            },
            {
                type: 'text',
                label: "Maximum Deal Size",
                dataKey: "maximum_size",
                ...validators.isNumberWhenStripped,
                ...formatters.USDCurrency
            },
            {
                type: 'text',
                label: "Minimum Deal Size in KWH",
                dataKey: "minimum_size_kwh",
                subLabel: "If a maximum is set in both dollars and kilowatt-hours, then the kilowatt hours max will be used for solar projects.",
                ...validators.isNumberWhenStripped,
                ...formatters.USDCurrency
            },
            {
                type: 'text',
                label: "Maximum Deal Size in KWH",
                subLabel: "If a maximum is set in both dollars and kilowatt-hours, then the kilowatt hours max will be used for solar projects.",
                dataKey: "maximum_size_kwh",
                ...validators.isNumberWhenStripped,
                ...formatters.USDCurrency
            },
            {
                type: 'text',
                label: "How much do you pay for each dollar of the 10% Energy Community Adder?",
                subLabel: "Value in $ the to cent..i.e.: $0.50",
                dataKey: "energy_community_adder_per_dollar",
                ...validators.isNumberWhenStripped,
                ...formatters.USDCurrency
            },
            {
                type: 'text',
                label: "How much do you pay for each dollar of the 10% Domestic Content “Made in USA” Adder?",
                subLabel: "Value in $ the to cent..i.e.: $0.50",
                dataKey: "domestic_content_adder_per_dollar",
                ...validators.isNumberWhenStripped,
                ...formatters.USDCurrency
            },
            {
                type: 'select',
                label: 'Application Template',
                dataKey: "application_template",
                options: []
            },
            {
                type: 'select',
                label: "Does this product allow a one time re-amortization post payment of rebates and tax incentives?",
                subLabel: "If so, add a note about conditions",
                dataKey: "is_prepayable",
                ...preconfiguredInputs.nullBooleanSelect,
            }

        ]

        this.specInstanceInputs_PACE = [
            {
                type: 'text',
                label: "Prepayment Penalty",
                dataKey: "pre_payment_penalty",
            },
            {
                type: 'text',
                label: "Max Loan to Value (as %)",
                dataKey: "max_loan_to_val_percent_req",
                ...validators.isNumberWhenStripped,
                ...formatters.percentage,
            },
            {
                type: 'text',
                label: "Max Post-Money Total LTV Accepted (as %)",
                subLabel: "How much clear equity needs to be left on the property after the PACE loan",
                dataKey: "post_pace_clear_equity_percent_req",
                ...validators.isNumberWhenStripped,
                ...formatters.percentage,
            }
        ]


        this.specInstanceInputs_PPA = [
            {
                type: 'text',
                label: "Fixed System Degradation (%)",
                subLabel: "By how much do we assume the system degrades every year? The default is .5%",
                dataKey: "fixed_system_degradation",
                ...validators.isNumberWhenStripped,
                ...formatters.percentage,
            },
            {
                type: 'text',
                label: "Inflation Expectation (%)",
                subLabel: "By how much do we expect recurrent expenses (see fees section below " +
                    "to create O&M and insurance costs) to inflate every year? If you leave blank, default is 2%",
                dataKey: "inflation_expectation",
                ...validators.isNumberWhenStripped,
                ...formatters.percentage,
            },
        ]

        this.createEditLoanAttributeInputs = [
            {
                type: 'text',
                label: "Term (in years)",
                dataKey: "term",
                ...validators.isNumber
            },
            {
                type: 'text',
                label: "Rate",
                dataKey: "rate",
                ...validators.isNumberWhenStripped,
                formatter: (val) => formatters.percentage.formatter(val, 2),
                otherInputs: [
                    {
                        type: 'select',
                        label: 'Type',
                        options: [
                            
                            {
                                display: "% Fixed",
                                value: "fixed"
                            },
                            {
                                display: "% + 5yr T-bill",
                                value: "float_w_5yr"
                            },
                            {
                                display: "% + 7yr T-bill",
                                value: "float_w_7yr"
                            },
                            {
                                display: "% + 10yr T-bill",
                                value: "float_w_10yr"
                            },
                            {
                                display: "% + 20yr T-bill",
                                value: "float_w_20yr"
                            },
                            {
                                display: "% + 30yr T-bill",
                                value: "float_w_30yr"
                            }
                        ],
                        dataKey: "rate_type",

                    },

                ]
            },
            {
                type: 'text',
                label: "Rate Floor",
                dataKey: "rate_min",
                ...validators.isNumberWhenStripped,
                formatter: (val) => formatters.percentage.formatter(val, 2),
            },
            {
                type: 'text',
                label: "Other Info",
                dataKey: "other_info",
            },
        ]

        this.createEditResidentialLoanAttributeInputs = [
            {
                type: 'text',
                label: "Term (in years)",
                dataKey: "term",
                ...validators.isNumber
            },
            {
                type: 'text',
                label: "Earliest year property-owner can take possession",
                dataKey: "earliest_year",
                ...validators.isNumber
            },
            {
                type: 'text',
                label: "Estimated purchase price per dollar of Investment Tax Credit",
                dataKey: "purchase_price_per_dollar",
                ...validators.isNumber,
                ...formatters.USDCurrency
            },
            {
                type: 'text',
                label: "Other Info",
                dataKey: "other_info",
            },
        ]

        this.createEditLoanAttributeInputs_PPA = [
            {
                type: 'text',
                label: "Term (in years)",
                dataKey: "term",
                ...validators.isNumber
            },
            {
                type: 'text',
                label: "Target IRR",
                dataKey: "rate",
                ...validators.isNumberWhenStripped,
                formatter: (val) => formatters.percentage.formatter(val, 2),
                otherInputs: [
                    {
                        type: 'select',
                        label: 'Type',
                        defaultValue: "fixed",
                        options: [
                            {
                                display: "% Fixed",
                                value: "fixed"
                            }
                        ],
                        dataKey: "rate_type",

                    },

                ]
            },
            {
                type: 'text',
                label: "Annual Riser (%)",
                subLabel: "Fix an annual riser to the cost of kwh.",
                dataKey: "annual_riser",
                ...validators.isNumber
            },
        ]

        this.createEditFeeInputs = [
            {
                type: 'text',
                label: "Name",
                dataKey: "name",
                ...validators.isStringOfMinLength(2)
            },
            {
                type: 'text',
                label: "Explanation",
                dataKey: "explanation",
            },
            {
                label: "Fee Type",
                dataKey: "type",
                ...preconfiguredInputs.loanFeeTypeSelect
            },

            {
                type: 'text',
                label: "Fee Structure",
                dataKey: "charge_amount",
                ...validators.isNumber,
                otherInputs: [
                    {
                        ...preconfiguredInputs.flatFeeChargeTypeSelect,
                        dataKey: "charge_type"
                    }
                ]
            },
            {
                type: 'text',
                label: "Project Cost Floor",
                subLabel: "The minimum size of the project to which you would like this applied. If this is set, this fee will be ignored for projects smaller than this number.",
                dataKey: "project_cost_floor",
                ...validators.isNumber,
                ...formatters.USDCurrency
            },
            {
                type: 'text',
                label: "Project Cost Ceiling",
                subLabel: "The maximum size of the project to which you would like this applied. If this is set, this fee will be ignored for projects that require more funding.",
                dataKey: "project_cost_ceil",
                ...validators.isNumber,
                ...formatters.USDCurrency
            },
            // TODO: ADD BASIS HERE... NOT SURE HOW THAT SHOULD BE ADDED.
        ]



    }

    componentDidMount() {
        toggleGlobalLoader(true)
        Promise.allSettled([
            this.getData(),
            this.getBusinessTypesForAddition(),
            this.getAssetTypesForAddition(),
            this.getImprovementsForAddition()
        ])
        .then(() => {
            toggleGlobalLoader(false);
            this.changeMode('term-sets')
        })
        .then(() => {
            let navInstructions = {...this.props.navInstructions};
             let {createAttribute} = navInstructions;
             if (createAttribute) {
                 this.setState({addEditAttributeModalOpen: true})
                 delete navInstructions.createAttribute;
                 this.props.updateNavInstructions(navInstructions);
             }
        })

    }

    toggleEditModal = () => {
        this.setState({editModalOpen: !this.state.editModalOpen})
    }


    getData = (xtraParams = {}) => {

        return api.get(this.baseAPIPath)
            .then(res => {
                this.setState({specInstance: res.data})
            })
            .catch(() => addErrorAlert('Data pull failed.'))
    };

    handleDeleteRequest = () => {
        api.patch(this.baseAPIPath, {is_active: 0})
            .then(() => window.location = '/admin/pace-programs/')
    }


    handleUpdateRequest = (data) => {

        if (data.type) data.type = +data.type;

        Object.keys({...data}).forEach(key => {
            if ([null, undefined, NaN].includes(data[key])) {
                delete data[key]
            }
        })

        api.patch(this.baseAPIPath, data)
            .then(() => this.getData())
            .catch(err => console.error(err))
            .finally(() => this.setState({editModalOpen: false, editingInstance: null}))
    }


    handleSearch = (val) => {
        this.setState({nameFilter: val},
            this.getData
        )
    }


    getPaceProgramsForAddition = (searchParam) => {
        let params = {limit: 100, searchVal: searchParam}

        this.setState({
            paceProgramAdditionSearchResults: []
        });

        if (searchParam.length < 2) return;

        return api.get('/pace-programs/', params)
            .then(res => {
                this.setState(
                    {
                        paceProgramAdditionSearchResults:
                            res.data.results.map(d => ({
                                ...d,
                                added: this.state.displayedData.filter(d => d.pace_program).map(d => d.pace_program.id).includes(d.id)
                            }))
                    })
            })
    }




    mapInputsToValues = (inputs, data) => {

        data = data || this.state.specInstance;

        return inputs.map(d => ({
            ...d,
            value: data[d.dataKey],
            otherInputs: [
                ...(d.otherInputs || []).map(o => ({...o, value: data[o.dataKey]}))
            ]
        }))
    }

    populateSpecInstanceInputsWithValues = () => {

        // we have type as a slug. So we find the id by matching to display. This should be updated in the future.
        let type_id = (preconfiguredInputs.loanProductTypeSelect.options.find(d => lowerCase(d.display) === lowerCase(this.state.specInstance.type)) || {}).value

        // add the template options to the inputs array
        this.editSpecInstanceInputs = this.editSpecInstanceInputs.map(d => {
            if (d.dataKey === 'application_template') {
                return {
                    ...d,
                    options: (this.state.specInstance?.funder?.application_templates || [])
                        .map(d => ({value: d.id, display: d.name}))
                }
            } 
                return d
            
        })

        let base = this.mapInputsToValues(this.editSpecInstanceInputs, {...this.state.specInstance, type: type_id})

        let type_specific = []

        if (this.state.specInstance.type === 'PACE') {
            type_specific = this.mapInputsToValues(this.specInstanceInputs_PACE)
        }


        if (this.state.specInstance.type === 'PPA') {
            type_specific = this.mapInputsToValues(this.specInstanceInputs_PPA)
        }


        return [...base, ...type_specific]
    }

    populateAttributeInputsWithValues = () => {
        let inputs;
        if (this.state?.specInstance?.type === 'PPA') {
            inputs = this.createEditLoanAttributeInputs_PPA
        }  
        else if (this.state?.specInstance?.type === 'Solar Power Agreement') {
            // residential
            inputs = this.createEditResidentialLoanAttributeInputs
        } 
        else {
            inputs = this.createEditLoanAttributeInputs
        }
        return this.mapInputsToValues(inputs, this.state.editingInstance || {})
    }


    populateFeeInputsWithValues = () => {
        return this.mapInputsToValues(this.createEditFeeInputs, this.state.editingInstance || {})
    }



    handlePaceProgramLoanProductDeleteRequest = (id, pace_program_id, pull_data = true) => {
        // you MUST pass loan_product id with all create/delete requests
        api.delete('/pace-program-loan-products/' + id, {loan_product: this.specInstanceId})
            .then(() => this.setState({
                editingInstance: null,
                deletePaceProgramLoanProductModalOpen: false,
                paceProgramAdditionSearchResults: this.state.paceProgramAdditionSearchResults.map(d => d.id === pace_program_id ? {
                    ...d,
                    added: false
                } : d)
            }))
            .then(() => pull_data ? this.getData().then(() => this.changeMode('pace-programs')) : () => {})
    }

    handlePaceProgramLoanProductCreateRequest = (pace_program_id) => {
        api.post('/pace-program-loan-products/', {loan_product: this.specInstanceId, pace_program: pace_program_id})
            .then(() => this.setState({
                paceProgramAdditionSearchResults: this.state.paceProgramAdditionSearchResults.map(d => d.id === pace_program_id ? {
                    ...d,
                    added: true
                } : d)
            }))
    }



    handleAddOrEditFeeRequest = (data) => {
        if (this.state.editingInstance) {
            return api.patch(`/loan-product-fees/${this.state.editingInstance.id}/`, data)
                .then(() => this.getData())
                .then(() => {
                    this.changeMode('fees')
                })
        } 
            return api.post(`/loan-product-fees/`, {...data, loan_product: this.specInstanceId})
                .then(() => this.getData())
                .then(() => {
                    this.changeMode('fees');
                })
        
    }




    handleAddOrEditAttributeRequest = (data) => {
        const payload = { ...data, loan_product: this.specInstanceId };
      
        if (payload.rate === undefined || payload.rate === null || payload.rate === '') {
          payload.rate = 0;
        }
      
        if (this.state.editingInstance) {
          return api.patch(`/loan-product-attributes/${this.state.editingInstance.id}/`, payload)
            .then(() => this.getData())
            .then(() => this.changeMode('term-sets'))
            .catch(err => console.error(err));
        } 
          return api.post(`/loan-product-attributes/`, payload)
            .then(() => this.getData())
            .then(() => this.changeMode('term-sets'))
            .catch(err => console.error(err));
        
      };


    handleAttributeRemoveRequest = () => {
        api.patch(`/loan-product-attributes/${this.state.editingInstance.id}/`, {is_active: 0})
            .then(() => this.getData())
            .then(() => {
                this.changeMode('term-sets');
                this.setState({deleteAttributeModalOpen: false})
            })
    }

    handleFeeRemoveRequest = () => {
        api.delete(`/loan-product-fees/${this.state.editingInstance.id}/`)
            .then(() => this.getData())
            .then(() => {
                this.changeMode('fees');
                this.setState({deleteFeeModalOpen: false})
            })
    }



    getBusinessTypesForAddition = () => {
        return api.get('/business-types-residential/', {cacheBust: getUUID()})
            .then(res => {
                this.setState({
                    businessTypeList: res.data// .map(d => ({...d, category: "Business Types"}))
                })
            })
    }

    getAssetTypesForAddition = () => {
        return api.get('/asset-types-residential/', {cacheBust: getUUID()})
            .then(res => {
                this.setState({
                    assetTypeList: res.data// .map(d => ({...d, category: "Business Types"}))
                })
            })
    }

    getImprovementsForAddition = () => {
        return api.get('/improvements/', {cacheBust: getUUID()})
            .then(res => {
                this.setState({
                    improvementList: res.data
                })
            })
            .catch(() => addErrorAlert('Failed to pull improvements.'))
    }


    handleLoanProductBusinessTypeExclusionCreateRequest = (business_type_id) => {
        return api.post('/loan-product-business-type-exclusions/', {business_type: business_type_id, loan_product: this.specInstanceId})
    }

    handleLoanProductBusinessTypeExclusionDeleteRequest = (business_type_id, pull_data = true) => {
        return api.delete('/loan-product-business-type-exclusions/0/',
            {loan_product: this.state.specInstance.id, business_type: business_type_id}
            )
    };


    handleBulkBusinessTypeExclusion = (selected, type_ids = []) => {

        const removeExclusionsFromState = () => {
            this.setState({
                specInstance: {
                    ...this.state.specInstance,
                    business_type_exclusions: get(this.state, 'specInstance.business_type_exclusions', [])
                        .filter(d => !type_ids.includes(d))
                }
            });
        }

        const addExclusionsToState = (created_exclusions) => {

            this.setState({
                specInstance: {
                    ...this.state.specInstance,
                    business_type_exclusions: [
                        ...get(this.state, 'specInstance.business_type_exclusions', []),
                        ...created_exclusions
                    ]
                }
            });
        }

        let promise;
        if (selected) {
            promise = Promise.all(type_ids.map(d => this.handleLoanProductBusinessTypeExclusionDeleteRequest(d)))
                .then(() => {
                    removeExclusionsFromState()
                })
                .catch(() => {
                    addErrorAlert("The update failed.")
                })

        } else {
            promise = Promise.all(type_ids.map(d => this.handleLoanProductBusinessTypeExclusionCreateRequest(d)))
                .then(res => {
                    let created_exclusions = res.map(d => d.data.business_type)
                    console.log(created_exclusions)
                    addExclusionsToState(created_exclusions)
                })
                .catch(() => {
                    // removeExclusionFromState();
                    addErrorAlert("The update failed.")
                })
        }

        return promise

    }


    handleBusinessTypeExclusion = (selected, id) => {

        this.handleBulkBusinessTypeExclusion(selected, [id])
    }


    handleLoanProductAssetTypeExclusionCreateRequest = (asset_type_id) => {
        return api.post('/loan-product-asset-type-exclusions/', {asset_type: asset_type_id, loan_product: this.specInstanceId})
    }

    handleLoanProductAssetTypeExclusionDeleteRequest = (asset_type_id) => {
        /*
        * Break traditional pattern of deleting by id here. We want all instances of an exclusion removed when we delete
        * We delete by passing funder and loan product id. The 0 id tells backed to look at query params
        * */
        return api.delete('/loan-product-asset-type-exclusions/0/',
            {loan_product: this.state.specInstance.id, asset_type: asset_type_id}
        )
    };


    handleBulkAssetTypeExclusion = (selected, asset_ids = []) => {

        const removeExclusionsFromState = () => {
            this.setState({
                specInstance: {
                    ...this.state.specInstance,
                    asset_type_exclusions: this.state.specInstance.asset_type_exclusions.filter(d => !asset_ids.includes(d))
                }
            });
        }

        const addExclusionsToState = (created_exclusions) => {

            this.setState({
                specInstance: {
                    ...this.state.specInstance,
                    asset_type_exclusions: [
                        ...this.state.specInstance.asset_type_exclusions,
                        ...created_exclusions
                    ]
                }
            });
        }

        let promise;
        if (selected) {
            let exclusions_to_delete = this.state.specInstance.asset_type_exclusions.filter(d => asset_ids.includes(d))
            promise = Promise.all(exclusions_to_delete.map(d => this.handleLoanProductAssetTypeExclusionDeleteRequest(d)))
                .then(() => {
                    removeExclusionsFromState()
                })
                .catch(() => {
                    addErrorAlert("The update failed.")
                })

        } else {
            promise = Promise.all(asset_ids.map(d => this.handleLoanProductAssetTypeExclusionCreateRequest(d)))
                .then(res => {
                    let created_exclusions = res.map(d => (d.data.asset_type))
                    console.log(created_exclusions)
                    addExclusionsToState(created_exclusions)
                })
                .catch(() => {
                    // removeExclusionFromState();
                    addErrorAlert("The update failed.")
                })
        }

        return promise
    }


    handleAssetTypeExclusion = (selected, id) => {
        return this.handleBulkAssetTypeExclusion(selected, [id])
    }


    handleBulkImprovementExclusion = (selected, ids = []) => {
        // where selected is a true or false boolean. Remember that is an exclusion, so a false selection is a create and a true selection is a delete.
         let improvement_exclusions = this.state.specInstance?.improvement_exclusions || [];
         let promise;


         if (selected) {
             let matching_exclusions = improvement_exclusions.filter(d => ids.includes(d.improvement))
             promise = Promise.all(
                 matching_exclusions.map(d => api.delete(`/loan-product-improvement-exclusions/${d.id}/`))
             )
         } else {
             // console.log("matching exclusions", matching_exclusions)
             promise = Promise.all(ids.map(id => (
                 api.post(`/loan-product-improvement-exclusions/`, {
                         improvement: id,
                         loan_product: this.state.specInstance.id
                     })
                 ))
             )
         }

         return promise
             .then(this.getData)
             .then(() => {
                 this.setState(
                     {displayedData: this.state.displayedData.map(d => ({...d, loading: false}))},
                     () => this.changeMode('improvements')
                 )
             })
    }

    handleImprovementExclusion = (selected, id) => {
        return this.handleBulkImprovementExclusion(selected, [id])
    }


    changeMode = mode => {
        let displayedData;
        if (mode === 'pace-programs') {
            displayedData = this.state.specInstance.pace_programs.map(d => ({...d, ...(d.pace_program || {}), id: d.id}))
        }

        if (mode === 'term-sets') {
            displayedData = (this.state.specInstance.attributes || [])
              .filter(d => d.is_active !== false)
              .map(d => ({
                ...d,
                _html_purchase_price_per_dollar: formatters.USDCurrency.formatter(d.purchase_price_per_dollar)
              }));
          }

        if (mode === 'fees') {
            displayedData = (this.state.specInstance.fees || [])
                .filter(d => d.is_active !== false)
                    .map(d => ({...d, _html_project_cost_floor: formatters.USDCurrency.formatter(d.project_cost_floor), _html_project_cost_ceil: formatters.USDCurrency.formatter(d.project_cost_ceil)}))
        }

        if (mode === 'notes') {
            displayedData = (this.state.specInstance.notes || [])
        }


        if (mode === 'improvements') {
            let {improvementList} = {...this.state};
            let improvement_exclusions = (this.state.specInstance?.improvement_exclusions || []).map(d => d.improvement)
            displayedData = improvementList.map(d => ({...d, selected: !improvement_exclusions.includes(d.id)}))
        }

        if (mode === 'asset-type') {
            let addedTypes;
            try {
                addedTypes = this.state.specInstance.business_types.map(d => d.business_type.id);
            } catch (e) {
                console.error(e);
                addedTypes = [];
            }
            this.setState({
                businessTypeList: this.state.businessTypeList.map(d => ({...d, category: "Business Types", selected: (d.id in addedTypes)}))
            })

        }

        // pull data again when leaving improvements so that it is updated.
        if (this.state.mode === 'improvements' &&  mode !=='improvements' && this.state.changedImprovements) {
            this.getData()
                .then(() => this.setState({changedImprovements: false}))
        }
        this.setState({
            mode,
            displayedData
        })
    }


    renderProgramSearchAndSelectElement = (result) => (
        <div className="ss-result">
            <span
                className="icon"
                onClick={() => {
                    if (result.added) {
                        let dpp_id = (this.state.displayedData.find(d => d.pace_program.id === result.id) || {}).id;
                        if (!dpp_id) return;
                        this.handlePaceProgramLoanProductDeleteRequest(dpp_id, result.id, false);
                    } else {
                        this.handlePaceProgramLoanProductCreateRequest(result.id);
                    }
                }}
            >
                {result.added ?
                    <i className="fas fa-check-square has-text-success"/> :
                    <i className="far fa-square"/>}
            </span>
            <span className="has-text-weight-semibold">{result.name}</span>
            <span>{result.description}</span>
        </div>
    )


    render() {
        let {specInstance} = this.state;
        let { asset_type_exclusions, business_type_exclusions } = this.state.specInstance;

        return (
            <AdminWrapper>
                {/* card containing the details of the spec instance */}
                <div className="section">
                    <div className="container is-fullhd mx-6">
                        <div className="box">
                            <h5 className="is-size-4">{specInstance.funder_name}</h5>
                            <div className="level">
                                <div className="level-left">
                                    <div className="level-item">
                                        <div>
                                        <h2 className="title is-3">
                                            {specInstance.name} ({specInstance.type})
                                        </h2>
                                            <p className="has-text-grey-light">
                                                Name only visible to you and PACE program administrators. Not shown on indicatives.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="level-left">
                                    <div className="level-item">
                                        <button
                                            className='button is-link'
                                            onClick={() => this.setState({editModalOpen: true})}
                                        ><i className="fas fa-pencil"/>Edit
                                        </button>
                                    </div>
                                    <div className="level-item">
                                        <button
                                            className='button is-danger'
                                            onClick={() => this.setState({deleteModalOpen: true})}
                                        >Delete
                                        </button>
                                    </div>
                                    <div className="level-item">
                                            <button
                                                className='button is-primary'
                                                onClick={() => this.props.history.goBack()}
                                            >Back
                                            </button>
                                    </div>
                                </div>
                            </div>
                            <p className="has-text-weight-bold mb-2">{specInstance.description}</p>

                            {[
                                ...this.populateSpecInstanceInputsWithValues()
                                    .filter(d => !['name', 'description', 'application_template'].includes(d.dataKey))
                            ]
                            .map(d => (
                                <p>
                                    <span className="mr-3">{d.label}:</span>
                                    <span>{displaySummaryData(specInstance[d.dataKey], d.dataKey, d.formatter)}</span>
                                </p>
                            ))}
                            <p>
                                <span className="mr-3">Application Template:</span>
                                <span>{
                                    ((this.state.specInstance?.funder?.application_templates || [])
                                        .find(d => +d.id === +this.state.specInstance?.application_template) || {}).name
                                }</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div className="section pt-2">
                    <div className="container is-fullhd mx-6">
                        <div className="tabs is-medium">
                            <ul>
                                <li
                                    className={this.state.mode === 'term-sets' ? 'is-active' : ''}
                                    onClick={() => this.changeMode('term-sets')}
                                >
                                    <a>
                                        <span>Terms</span>
                                    </a>
                                </li>
                                <li
                                    className={this.state.mode === 'fees' ? 'is-active' : ''}
                                    onClick={() => this.changeMode('fees')}
                                >
                                    <a>
                                        <span>Fees</span>
                                    </a>
                                </li>
                                <li
                                    className={this.state.mode === 'notes' ? 'is-active' : ''}
                                    onClick={() => this.changeMode('notes')}
                                >
                                    <a>
                                        <span>Notes</span>
                                    </a>
                                </li>
                                {this.state.specInstance.type === "PACE" &&
                                <li
                                    className={this.state.mode === 'pace-programs' ? 'is-active' : ''}
                                    onClick={() => this.changeMode('pace-programs')}
                                >
                                    <a>
                                        <span>Pace Programs</span>
                                    </a>
                                </li>}
                                {SHOW_BUSINESS_ASSET_TABS && (
                                    <li
                                        className={this.state.mode === 'business-types' ? 'is-active' : ''}
                                        onClick={() => this.changeMode('business-types')}
                                    >
                                        <a><span>Business Types</span></a>
                                    </li>
                                )}
                                {SHOW_BUSINESS_ASSET_TABS && (
                                    <li
                                        className={this.state.mode === 'asset-types' ? 'is-active' : ''}
                                        onClick={() => this.changeMode('asset-types')}
                                    >
                                        <a><span>Asset Types</span></a>
                                    </li>
                                )}
                                <li
                                    className={this.state.mode === 'improvements' ? 'is-active' : ''}
                                    onClick={() => this.changeMode('improvements')}
                                >
                                    <a>
                                        <span>Improvements</span>
                                    </a>
                                </li>
                            </ul>
                        </div>

                        {/* AttributeS CODE */}
                        {this.state.mode === 'term-sets' &&
                        <>
                            <div className="level">
                                <div className="level-left">
                                    <div className="level-item">
                                        <h4 className="title is-4">Manage Loan Product Terms</h4>
                                    </div>
                                </div>
                                <div className="level-right">
                                    <div className="level-item">
                                        <button
                                            className='button is-link'
                                            onClick={() => this.setState({addEditAttributeModalOpen: true, editingInstance: null})}
                                        >+ Add Term</button>
                                    </div>

                                </div>
                            </div>
                            <PaginatedTable
                                className="is-fullwidth is-hoverable"
                                data={this.state.displayedData}
                                columns={['term', 'earliest_year', '_html_purchase_price_per_dollar', 'other_info']}
                                columnLabels={{
                                    'term': 'Term', 
                                    'earliest_year': 'Earliest year property-owner can take possession', 
                                    '_html_purchase_price_per_dollar': 'Estimated purchase price per dollar of Investment Tax Credit',
                                    'other_info': 'Other Info'
                                }}
                                showSortBar={false}
                                showPageNavigators={false}
                                actions={[
                                    {
                                        name: 'Edit',
                                        elem: (
                                            <span className="icon has-text-info">
                                                <i className="fas fa-edit"/>
                                            </span>
                                        ),
                                        action: (data) => this.setState({
                                            editingInstance: {...data}
                                        }, () => this.setState({addEditAttributeModalOpen: true}))
                                    },
                                    {
                                        name: 'Delete',
                                        elem: (<span className="icon has-text-danger">
                                                <i className="fas fa-minus-square"/>
                                            </span>),
                                        action: (data) => this.setState({
                                            deleteAttributeModalOpen: true,
                                            editingInstance: {...data}
                                        })
                                    }
                                ]}
                            />
                        </>
                        }

                        {this.state.mode === 'fees' &&
                        <>
                            <div className="level">
                                <div className="level-left">
                                    <div className="level-item">
                                        <h4 className="title is-4">Manage Loan Product Fees</h4>
                                    </div>
                                </div>
                                <div className="level-right">
                                    <div className="level-item">
                                        <button
                                            className='button is-link'
                                            onClick={() => this.setState({addEditFeeModalOpen: true, editingInstance: null})}
                                        >+ Add Fee</button>
                                    </div>

                                </div>
                            </div>
                            <PaginatedTable
                                className="is-fullwidth is-hoverable"
                                data={this.state.displayedData}
                                columns={[ 'name', 'explanation', 'type', 'generated_desc', 'project_cost_floor', 'project_cost_ceil']}
                                showSortBar={false}
                                showPageNavigators={false}
                                actions={[
                                    {
                                        name: 'Edit',
                                        elem: (
                                            <span className="icon has-text-info">
                                                <i className="fas fa-edit"/>
                                            </span>
                                        ),
                                        action: (data) => this.setState({
                                            addEditFeeModalOpen: true,
                                            editingInstance: {...data}
                                        })
                                    },
                                    {
                                        name: 'Delete',
                                        elem: (<span className="icon has-text-danger">
                                                <i className="fas fa-minus-square"/>
                                            </span>),
                                        action: (data) => this.setState({
                                            deleteFeeModalOpen: true,
                                            editingInstance: {...data}
                                        })
                                    }
                                ]}
                            />
                        </>
                        }

                        {/* NOTES */}

                        {this.state.mode === 'notes' &&
                        <>
                            <div className="level">
                                <div className="level-left">
                                    <div className="level-item">
                                        <h4 className="title is-4">Manage Loan Product Notes</h4>
                                    </div>
                                </div>
                                <div className="level-right">
                                    <div className="level-item">
                                        {/* <button */}
                                        {/*    className='button is-link' */}
                                        {/*    onClick={() => this.setState({addEditNoteModalOpen: true, editingInstance: null})} */}
                                        {/* >+ Add Note</button> */}
                                    </div>

                                </div>
                            </div>
                            <NoteBuilder notes={this.state.displayedData} loan_product={{id: this.state.specInstance.id}}/>
                        </>
                        }

                        {/* PACE PROGRAMS CODE */}
                        {this.state.mode === 'pace-programs' &&
                        <>
                            <div className="level">
                                <div className="level-left">
                                    <div className="level-item">
                                        <h4 className="title is-4">Manage Pace Programs</h4>
                                    </div>
                                </div>
                                <div className="level-right">
                                    <div className="level-item">
                                        <button
                                            className='button is-link'
                                            onClick={() => this.setState({addPaceProgramLoanProductModalOpen: true})}
                                        >+ Add Pace Program</button>
                                    </div>

                                </div>
                            </div>
                            <PaginatedTable
                                className="is-fullwidth is-hoverable"
                                data={this.state.displayedData}
                                columns={['name', 'description']}
                                showSortBar={false}
                                showPageNavigators={false}
                                actions={[
                                    {
                                        name: 'Delete',
                                        elem: (<span className="icon has-text-danger">
                                                <i className="fas fa-minus-square"/>
                                            </span>),
                                        action: (data) => this.setState({
                                            deletePaceProgramLoanProductModalOpen: true,
                                            editingInstance: {...data}
                                        })
                                    }
                                ]}
                            />
                        </>
                        }


                        {/* BUSINESS TYPES CODE */}
                        {this.state.mode === 'business-types' &&
                        <>
                            <div className="level">
                                <div className="level-left">
                                    <div className="level-item">
                                        <h4 className="title is-5">Check a box to select</h4>
                                    </div>
                                </div>
                                <div className="level-right">
                                    <div className="level-item">
                                        <div className="buttons">
                                            {/* <Link to={'/admin/business-types'} target="_blank"> */}
                                            {/*    <button */}
                                            {/*        className='button' */}
                                            {/*    >+ Create New Business */}
                                            {/*    </button> */}
                                            {/* </Link> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <SelectByCategory
                                data={this.state.businessTypeList.map(d => (
                                        {
                                            ...d,
                                            category: "Business Types",
                                            selected: !business_type_exclusions.includes(d.id)
                                        }
                                    ))}
                                onOptionValueChange={this.handleBusinessTypeExclusion}
                                onBulkOptionValueChange={this.handleBulkBusinessTypeExclusion}
                            />
                        </>
                        }

                        {this.state.mode === 'asset-types' &&
                        <>
                            <div className="level">
                                <div className="level-left">
                                    <div className="level-item">
                                        <h4 className="title is-5">Check a box to select</h4>
                                    </div>
                                </div>
                                <div className="level-right">
                                    <div className="level-item">
                                        <div className="buttons">
                                            {/* <Link to={'/admin/business-types'} target="_blank"> */}
                                            {/*    <button */}
                                            {/*        className='button' */}
                                            {/*    >+ Create New Business */}
                                            {/*    </button> */}
                                            {/* </Link> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <SelectByCategory
                                data={this.state.assetTypeList.map(d => (
                                    {
                                        ...d,
                                        category: "Asset Types",
                                        selected: !asset_type_exclusions.includes(d.id)
                                    }
                                ))}
                                onOptionValueChange={this.handleAssetTypeExclusion}
                                onBulkOptionValueChange={this.handleBulkAssetTypeExclusion}
                            />
                        </>
                        }

                        {this.state.mode === 'improvements' &&
                            <>
                                <div className="level">
                                    <div className="level-left">
                                        <div className="level-item">
                                            <h4 className="title is-4">Manage Improvements</h4>
                                        </div>
                                    </div>
                                    <div className="level-right" />
                                </div>
                                <SelectByCategory
                                    data={this.state.displayedData}
                                    onBulkOptionValueChange={this.handleBulkImprovementExclusion}
                                    onOptionValueChange={this.handleImprovementExclusion}
                                />
                            </>
                        }

                    </div>
                </div>

                <FormModal
                    title={'Edit ' + this.state.specInstance.name}
                    visible={this.state.editModalOpen}
                    inputs={this.populateSpecInstanceInputsWithValues()}
                    disableAutocomplete
                    onSubmit={this.handleUpdateRequest}
                    onCancel={() => this.setState({editModalOpen: false, editingInstance: null})}
                />

                {!!this.state.addEditAttributeModalOpen && <FormModal
                    title={this.state.editingInstance ? 'Edit Term' : 'Create Term'}
                    visible
                    inputs={this.populateAttributeInputsWithValues()}
                    disableAutocomplete
                    onSubmit={data => this.handleAddOrEditAttributeRequest(data)
                        .then(() => this.setState({addEditAttributeModalOpen: false, editingInstance: null, resetAttributeForm: this.state.resetAttributeForm + 1}))}
                    onCancel={() => this.setState({addEditAttributeModalOpen: false, editingInstance: null})}
                    reset={this.state.resetAttributeForm}
                />}

                {this.state.addEditFeeModalOpen && <FormModal
                    title={this.state.editingInstance ? 'Edit Fee' : 'Create Fee'}
                    visible
                    inputs={this.populateFeeInputsWithValues()}
                    disableAutocomplete
                    onSubmit={data => this.handleAddOrEditFeeRequest(data)
                        .then(() => this.setState({addEditFeeModalOpen: false, editingInstance: null, resetFeeForm: this.state.resetFeeForm + 1}))}
                    onCancel={() => this.setState({addEditFeeModalOpen: false, editingInstance: null})}
                    reset={this.state.resetFeeForm}
                />}



                {/* delete the loan product itself */}
                <ConfirmModal
                    type="warning"
                    visible={this.state.deleteModalOpen}
                    prompt={!!this.state.specInstance && `Are you sure you want to deactivate ${this.state.specInstance.name}?`}
                    onCancel={() => this.setState({deleteModalOpen: false, editingInstance: null})}
                    onAccept={this.handleDeleteRequest}
                />

                {/* Delete pace program loan product */}
                <ConfirmModal
                    type="warning"
                    visible={this.state.deletePaceProgramLoanProductModalOpen}
                    prompt={!!this.state.editingInstance && `Are you sure you want to remove this product from the ${this.state.editingInstance.name}'s funding options?`}
                    onCancel={() => this.setState({deletePaceProgramLoanProductModalOpen: false, editingInstance: null})}
                    onAccept={() => this.handlePaceProgramLoanProductDeleteRequest(this.state.editingInstance.id)}
                />

                {/* Delete loan product attribute */}
                <ConfirmModal
                    type="warning"
                    visible={this.state.deleteAttributeModalOpen}
                    prompt={!!this.state.editingInstance && `Are you sure you want to remove the ${this.state.editingInstance.rate}%
                                for ${this.state.editingInstance.term} months term from this loan?`}
                    onCancel={() => this.setState({deleteAttributeModalOpen: false, editingInstance: null})}
                    onAccept={() => this.handleAttributeRemoveRequest(this.state.editingInstance.id)}
                />

                {/* Delete loan product fee */}
                <ConfirmModal
                    type="warning"
                    visible={this.state.deleteFeeModalOpen}
                    prompt={!!this.state.editingInstance && `Are you sure you want to remove the fee titled ${this.state.editingInstance.name}
                                 from this loan?`}
                    onCancel={() => this.setState({deleteFeeModalOpen: false, editingInstance: null})}
                    onAccept={() => this.handleFeeRemoveRequest(this.state.editingInstance.id).then(() => { this.setState({deleteFeeModalOpen: false, editingInstance: null}) })}
                />


                {/*  Search for an add pace programs to loan products  */}
                <SearchAndSelectModal
                    title="Make pace programs eligible for this loan."
                    visible={this.state.addPaceProgramLoanProductModalOpen}
                    onCancel={() => this.setState({addPaceProgramLoanProductModalOpen: false},
                        () => this.getData().then(() => this.changeMode('pace-programs')))}
                    handleSearch={(val) => this.getPaceProgramsForAddition(val)}
                    results={this.state.paceProgramAdditionSearchResults}
                    renderResultElement={this.renderProgramSearchAndSelectElement}
                />

            </AdminWrapper>
        )
    }

}


const mapStateToProps = state => ({
    navInstructions: state.session.navInstructions
})


const mapDispatchToProps = dispatch => ({
    updateNavInstructions: data => dispatch(actions.session.updateNavInstructions(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(SPACommercialLoanProductSpecScreen)

